import state from "@/store/subscriptionplan/state";
import actions from "@/store/subscriptionplan/actions";
import mutations from "@/store/subscriptionplan/mutations";
import getters from "@/store/subscriptionplan/getters";

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
